// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__gLD_C","footer":"ModalInfo_footer__TZeEv"};